import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSimplrAccountIdOfSelectedTicket } from 'extractFromState';
import { getProducts } from 'actions/tools/CommonProductActions';
import { selectSelectedToolDomains, getProductsList, getOrderSearchQuery } from 'selectors/tools';
import DTSearchView from 'components/DecisionTree/Common/DTSearchView/DTSearchView';
import ProductSearchResults from './Common/ProductSearchResults/ProductSearchResults';
import { setSearchOrdersQuery } from 'actions/tools/OrdersSearchActions';
import NoProductResults from './Common/NoProductResults/NoProductResults';

const PRODUCT_SEARCH_TYPE = 'productSearchString';

const DTProductSearchView = (props) => {
  const { onNextButtonClick, isNextButtonActive } = props;
  const dispatch = useDispatch();
  const productSearchQuery = useSelector(getOrderSearchQuery);
  const simplrAccountId = useSelector(getSimplrAccountIdOfSelectedTicket);
  const productsList = useSelector(getProductsList);

  /**
   * Currently, this node only supports Ember's Shopify integration.
   * As part of this feature, we do not search for an order which does
   * not get us the shop name respective to the partner and the order.
   *
   * For now, we directly grab the first shopify domain to satisfy the
   * MVP for this feature.
   */
  const toolDomains = useSelector(selectSelectedToolDomains);
  const shopName = toolDomains.shopify[0];

  const fetchProductsFromSearch = useCallback(async () => {
    const productSearchPayload = {
      sku: productSearchQuery,
      simplrAccountId,
      shopName,
    };

    await dispatch(getProducts(productSearchPayload));
  }, [dispatch, simplrAccountId, shopName, productSearchQuery]);

  useEffect(() => {
    if (productSearchQuery) {
      fetchProductsFromSearch();
    }
  }, [productSearchQuery, fetchProductsFromSearch]);

  const handleSearchSubmit = (value) => {
    dispatch(setSearchOrdersQuery(value));
  };

  return (
    <DTSearchView
      isNextButtonActive={isNextButtonActive}
      onNextButtonClick={onNextButtonClick}
      handleSearchSubmit={handleSearchSubmit}
      searchType={PRODUCT_SEARCH_TYPE}
      dataToDisplay={productsList}
      searchPageSelectComponent={null}
      searchResultsComponent={<ProductSearchResults productSearchResultList={productsList} />}
      noDataMessageComponent={<NoProductResults />}
      placeholder={'Enter the item SKU'}
      data-testid={'product-search-view'}
    />
  );
};

export default DTProductSearchView;
